import { render, staticRenderFns } from "./Drawdown.vue?vue&type=template&id=c0aab132&scoped=true&"
import script from "./Drawdown.vue?vue&type=script&lang=ts&setup=true&"
export * from "./Drawdown.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./Drawdown.vue?vue&type=style&index=0&id=c0aab132&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0aab132",
  null
  
)

export default component.exports